import type { GetPlansApiQuery } from "@/Modules/Models/Api/Plan";
import { ONBOARDING_SOURCE } from "@/Modules/Models/Domain/Plan";

import { getPlans } from "@/Services/TherapyApi/Plans";

import PlanTransformer from "@/Modules/Transformers/Plan";

import usePlanStore from "@/Modules/Plan/Store";

import { log } from "@/Utils/Debug";

async function fetchPlansAH(userId: string, comeFromOnboarding: boolean) {
  const planStore = usePlanStore();

  planStore.loading = true;

  try {
    const getPlansApiQuery: GetPlansApiQuery = {
      page_size: 100,
      user_uuid: userId,
      source: comeFromOnboarding ? ONBOARDING_SOURCE : undefined,
    };

    const planApiResponse = await getPlans(getPlansApiQuery);

    planStore.plans = planApiResponse.body.map(PlanTransformer.toDomain);

    return planStore.plans;
  } catch (error) {
    log("Error fetch plans", error);
  } finally {
    planStore.loading = false;
  }
}
export default fetchPlansAH;
